module.exports = __webpack_public_path__ + "img/ep-fantome.a76ffa16.jpg";